import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CreateServiceTypeComponent = loadable(
  () => import("../../components/ServiceType/CreateServiceType")
);
const CreateServiceType = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["service-type"],
    navigateURL: "/service-type",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.SERVICE_TYPE}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Service Type
        </span>
      </div>
      <CreateServiceTypeComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateServiceType;
